import Player from "../player";

export default class RemotePlayer extends Player {

    constructor(packets: any[]){
        super();
    }

    isLocal(): boolean {
        return false
    }
}